import { SyntheticEvent, useCallback, useState } from 'react';

const useAccordionPanel = () => {
  const [expandedPanelIds, setExpandedPanelIds] = useState<Set<string>>(new Set());

  const handleToggle = useCallback(
    (panelId: string) => (_event: SyntheticEvent, isExpanded: boolean) => {
      setExpandedPanelIds(prev => {
        const next = new Set(prev);
        if (isExpanded) next.add(panelId);
        else next.delete(panelId);
        return next;
      });
    },
    [],
  );

  return {
    expandedPanelIds,
    handleToggle,
  };
};

export default useAccordionPanel;
